import { styled } from '@mui/material/styles';

const UnstyledButton = styled('button')`
  padding: 0;
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

export default UnstyledButton;
